import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/router';
import { useAccountUIApiBasePath } from '../../provider';
export function useGetApiCacheKey() {
  const $ = _c(3);
  const baseUrl = useAccountUIApiBasePath();
  const router = useRouter();
  const appBasePath = router?.basePath || "";
  let t0;
  if ($[0] !== appBasePath || $[1] !== baseUrl) {
    t0 = url => `${appBasePath}${baseUrl}${url}`;
    $[0] = appBasePath;
    $[1] = baseUrl;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}